<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <h2 class="brand-text text-primary ml-1">
            RättVisat
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Glömt ditt lösenord?
        </b-card-title>
        <b-card-text class="mb-2">
          Ange din mailadress så skickar vi en länk för återställning av ditt
          lösenord.
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <b-form-group label="Mailadress" label-for="forgot-password-email">
              <validation-provider
                #default="{ errors }"
                name="Mailadress"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="forgot-password-email"
                  placeholder="Mailadress..."
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" block type="submit">
              Skicka länk
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{ name: 'login' }">
            <feather-icon icon="ChevronLeftIcon" /> Logga in
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import userAccountService from "@/services/user-account.service";
import emailService from "@/services/mail.service";

export default {
  components: {
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: "",
      // validation
      required,
      email,
      locale: "sv",
    };
  },
  mounted() {
    localize(this.locale);
  },
  methods: {
    userNotification: function(title, message, icon) {
      this.$swal({
        title: title,
        text: message,
        icon: icon,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    validationForm: function() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          userAccountService
            .initiateResetPassword(this.userEmail)
            .then((res) => {
              const substituteData = {
                First_Name: res.data.first_name,
                Last_Name: res.data.last_name,
                Reset_Token: res.data.reset_token,
              };
              emailService
                .sendEmail(
                  "reset_password",
                  res.data.email,
                  substituteData,
                  false
                )
                .then((res) => {
                  if (res) {
                    this.userNotification(
                      "Mail skickat!",
                      "Vi har skickat ett mail till dig som innehåller länk för att återställa ditt lösenord 😃👍",
                      "success"
                    );
                  } else {
                    this.userNotification(
                      "Det gick inte skicka mailet",
                      "Ajdå! Något gick fel och vi kunde inte skicka mailet...😖 Vänligen försök igen 😃👍",
                      "error"
                    );
                  }
                })
                .catch(() => {
                  this.userNotification(
                    "Det gick inte skicka mailet",
                    "Ajdå! Något gick fel och vi kunde inte skicka mailet...😖 Vänligen försök igen 😃👍",
                    "error"
                  );
                });
            })
            .catch(() => {
              this.userNotification(
                "Inte registrerad",
                "Din mailadress finns inte registrerad hos oss.",
                "error"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
